<template>
  <span v-if="toBeDisplayed.trim().length > 0" class="contract" v-html="toBeDisplayed.trim().length > 0 ? toBeDisplayed : '\xa0'"></span>
</template>

<script>
import {suitHtml} from "../../lib/cardSuits";

export default {
  name: 'Contract',
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: {
    baseLang() {
      return this.$i18n.messages[this.$i18n.locale];
    },
    convertedSuit() {
      return suitHtml[this.contract.suit] ?? '';
    },
    convertedDouble() {
      return 'x'.repeat(this.contract.dbl);
    },
    convertedDeclarer() {
      return this.baseLang.positions[this.contract.declarer] ?? '';
    },
    convertedTricks() {
      return this.contract.tricks ?? '';
    },
    convertedLevel() {
      return this.contract.level ?? '';
    },
    toBeDisplayed() {
      if (this.convertedLevel === 0) {
        return "Pass"
      }
      return this.convertedLevel + ' ' +
          this.convertedSuit + ' ' +
          this.convertedDouble + ' ' +
          this.convertedDeclarer + ' ' +
          this.convertedTricks;
    }
  }
};
</script>

<style scoped>
.contract {
  display: inline-block;
  border-radius: 99rem;
  border: 1px solid black;
  padding: 0 1rem;
  margin: auto;
}

/deep/ ._htmlSuiteClass {
  font-size: larger;
}
</style>
